import { Component, OnInit, ViewChild, AfterContentInit, Input } from '@angular/core';
import { JqueryHelperService } from '../jquery-helper.service';
import { Filter, FilterType } from '../models/Filter';
import { Observable } from 'rxjs/Observable';
import { FilterService } from '../shared/filter.service';
import { AppState } from '../models/app.state';
import { Store } from '@ngrx/store';
import { ChangeLanguageAction } from '../actions/lang.action';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ciu-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.css']
})
export class MobileMenuComponent implements OnInit {
  // @ViewChild(ProductfilterComponent) child: ProductfilterComponent;

  isOpenMenu = false;
  @Input() isWindow = false;
  constructor(private jqueryHelper: JqueryHelperService,
    private store: Store<AppState>,
    private translateService: TranslateService,
    private filterService: FilterService
  ) {
    this.activeFilters$ = this.filterService.getActiveFilteres();
    this.categories$ = this.store.select('lang');
    this.store.select((data) => {
      return data.filters.filter(f => f.type === FilterType.SEARCH)[0] ? data.filters.filter(f => f.type === FilterType.SEARCH)[0].value.toString() : '';
    }).subscribe(s => this.searchWord = s);
  }
  searchWord: string;
  activeFilters$: Observable<Filter[]>;
  categories$: Observable<string>;

  ngOnInit() {
    // this.jqueryHelper.test();

    this.jqueryHelper.initMobileMenu();
    this.jqueryHelper.onPageScroll();

  }

  search() {
    this.filterService.search(this.searchWord);
  }

  getFilters(filters: Filter[]) {
    if (this.isWindow) {
      return filters.filter(f => f.type === FilterType.SEARCH);
    }
    return filters;
  }

  removeFilter(filter: Filter) {
    this.filterService.removeFilter(filter);
    if (filter.type === FilterType.SEARCH) {
      // this.searchWord = '';
      this.jqueryHelper.resetSearchInput();
    }

    if (filter.type === FilterType.GEO) {
      this.jqueryHelper.refreshGeofilter();
    }

    if (filter.type === FilterType.PRICE) {
      this.jqueryHelper.refreshPricefilter();
    }
    // this.jqueryHelper.changeSlider('desktop');
    // this.jqueryHelper.changeSlider('mobile');
  }

  onMenuItemClick() {
    this.isOpenMenu = !this.isOpenMenu; this.jqueryHelper.isMenuOpen(this.isOpenMenu);
  }
  changeLanguage(lang: 'de' | 'en' | 'it' | 'fr') {
    this.translateService.use(lang);
    this.store.dispatch(new ChangeLanguageAction(lang));
  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/mobile-menu/mobile-menu.component.ts